import ActivityRowItem from "@/components/_module/home/activityRowItem/index";
// import AprOptions from "@/components/_module/home/aprOptions";
// import HomeInvite from "@/components/_module/home/homeInvite";
import HomeHeader from "@/components/pages/home/header";
import { Button, buttonVariants } from "@/components/ui/button/button";
import PaymentCard from "@/components/ui/paymentCard";
import { isSetupComplete } from "@/utils/setup";
import { Link, useLoaderData, useNavigate } from "@tanstack/react-router";
import AddEinNoticeCard from "./AddEinNoticeCard";
import HelpWithSetupCard from "./HelpWithSetupCard";

const VerifiedHome = () => {
	const navigate = useNavigate();
	const { creditCards, bankAccounts, transactionsData } = useLoaderData({
		from: "/main",
	});

	const transactions = transactionsData?.data ?? [];
	const setupComplete = isSetupComplete(
		creditCards,
		bankAccounts,
		transactions,
	);
	const recentActivities = {
		...transactionsData,
		data: transactions.slice(0, 3),
	};

	return (
		<>
			<HomeHeader />
			<div>
				<div className="px-6 mt-6">
					{!setupComplete && <HelpWithSetupCard />}

					<AddEinNoticeCard />

					<div className="flex items-center justify-between mt-6 mb-6">
						<h2 className="text-lg font-bold text-textDark">My Cards</h2>
						<Link
							to={"/main/card/new"}
							className={buttonVariants({
								variant: "link",
								size: "compact",
							})}
						>
							+ Add Card
						</Link>
					</div>

					<div className="space-y-3">
						{creditCards.map((creditCard) => (
							<PaymentCard key={creditCard.id} card={creditCard} />
						))}
					</div>
				</div>

				{/* Recent Activity */}
				{recentActivities?.data && recentActivities?.data?.length > 0 && (
					<div className="px-6 mt-8">
						<div className="flex items-center justify-between mb-4">
							<h2 className="text-lg font-bold text-textDark">
								Recent Activity
							</h2>
							<Button
								variant="link"
								size="compact"
								className="font-medium opacity-80"
								onClick={() =>
									navigate({
										to: "/main/activity",
									})
								}
							>
								See all
							</Button>
						</div>
						<div className="space-y-4">
							{recentActivities?.data.slice(0, 3).map((activity) => (
								<ActivityRowItem
									key={activity.transaction_id}
									transaction={activity}
								/>
							))}
						</div>
					</div>
				)}

				{/* Invite Friends*/}
				{/* <div className="px-6 mt-6">
					<HomeInvite code={user.referral_code} />
				</div> */}

				{/* APR Offer */}
				{/* <AprOptions /> */}
			</div>
		</>
	);
};

export default VerifiedHome;
